import * as React from 'react';

import styled from 'styled-components';

import { Option } from '@webapp/types/common/option';

import Helper from '@components/basics/helper';
import Typography from '@components/basics/typography';

export interface ToggleProps {
  className?: string;
  value?: any;
  options: Option<any>[];
  border?: boolean;
  bigFont?: boolean;
  decoration?: React.ReactElement;
  disabled?: boolean;
  onChange: (value: any) => void;
}

export const Toggle: React.FC<ToggleProps> = (props) => {
  const [isHover, setHover] = React.useState<number>();

  const handleClick = (newValue: string) => {
    props.onChange(newValue);

    return false;
  };

  return (
    <WrapperToggle className={props.className}>
      {props.options.map((option, i) => (
        <div
          key={option.value}
          onMouseEnter={() => setHover(i)}
          onMouseLeave={() => setHover(undefined)}
        >
          <Typography
            className={`toggle-text ${
              option.value === props.value ? 'active' : ''
            } ${props.disabled || option.disabled ? 'disabled' : ''}`}
            type="big-title"
            customFont={option.value === props.value ? 'semi-bold' : 'medium'}
            onClick={(ev) => {
              ev.stopPropagation();
              handleClick(option.value);
            }}
          >
            {option.decoration ? (
              <div className="toggle-decoration">{option.decoration}</div>
            ) : null}
            {option.label}
          </Typography>
          {option.helpText ? (
            <Helper isHover={isHover === i}>{option.helpText}</Helper>
          ) : null}
        </div>
      ))}
    </WrapperToggle>
  );
};

export default styled(Toggle)`
  .toggle-text {
    cursor: pointer;
    word-break: break-word;
    color: ${({ theme }) => theme.colors.tertiary};

    &:hover,
    &.active {
      color: ${({ theme }) => theme.colors.primary};
    }
  }
`;

export const WrapperToggle = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 20px;
`;
